// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3FfZs","alertIcon":"ConfirmModal_alertIcon__v30ls"};